import { Channel } from '@/types/channel';
import type { Message } from '@/types/message';

const CHANNEL_LABELS: Record<string, string> = {
  [Channel.CHAT]: 'Chat',
  [Channel.EMAIL]: 'Email',
  [Channel.PUSH]: 'Push',
  [Channel.SMS]: 'Text',
  [Channel.VOICE]: 'call'
};

/** "Outbound call", "Text" -- a call reads better with its direction. */
export const messageTitle = (message: Message) => {
  const label = CHANNEL_LABELS[message.channel] ?? message.channel;

  if (message.channel !== Channel.VOICE) return label;

  return `${message.direction === 'in' ? 'Inbound' : 'Outbound'} ${label}`;
};
